import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withPagination } from '@shared/store/pagination.feature';
import { TrigrammeTypeCertification } from '../models/trigramme-type-certification.model';
import { initialState, TrigrammeTypeCertificationState } from './trigramme-type-certification.state';
import { avecMéthodesTrigrammeTypeCertification } from './trigrammes-type-certification.methods';

export const TrigrammeTypeCertificationStore = signalStore(
  { providedIn: 'root' },
  withState<TrigrammeTypeCertificationState>(initialState),
  withEntities<TrigrammeTypeCertification>(),
  avecMéthodesTrigrammeTypeCertification(),
  withPagination<TrigrammeTypeCertification>(),
);
